<template>
  <div>
    <AAlert
      v-if="errorMessage"
      type="error"
      :message="errorMessage"
      banner
      closable
      @close="errorMessage = null"
    />

    <!-- filter -->
    <ARow :gutter="[8, 8]">
      <ACol :xl="6" :md="8" :sm="12" :span="24">
        <FilterOpco style="width:100%;" v-model:value="state.params.opco" />
      </ACol>
      <ACol :xl="6" :md="8" :sm="12" :span="24">
        <FilterProvince style="width:100%;" v-model:value="state.params.provinsi" />
      </ACol>
      <ACol :xl="6" :md="8" :sm="12" :span="24">
        <FilterCLusterMaster style="width:100%;" v-model:value="state.params.cluster" />
      </ACol>
      <ACol :xl="6" :md="8" :sm="12" :span="24">
        <AButton type="primary" title="cari" @click="fetchDataList" :loading="state.isFetching">
          <span v-if="!state.isFetching" class="fa fa-search" aria-hidden="true" />
          <span v-else>
            Memuat Data ...
          </span>
        </AButton>
      </ACol>
    </ARow>

    <!-- button action menu -->
    <div class="row justify-content-end mt-4">
      <div class="col-lg-6 col-md-12"></div>
      <div class="col-lg-6 col-md-12 text-right">
        <ASpace>
          <ATooltip title="Tambahkan">
            <AButton type="primary" @click="btnForm">
              <i class="fa fa-plus" aria-hidden="true"></i>
            </AButton>
          </ATooltip>
          <ATooltip title="Download excel">
            <DownloadExcel
              :url="state.endpoint.current"
              :params="state.params"
              @errors="errorMessage"
            />
          </ATooltip>
        </ASpace>
      </div>
    </div>

    <!-- list table -->
    <div class="table-responsive text-nowrap mt-4">
      <MdTable
        :columns="state.columns"
        :data-source="state.data"
        size="small"
        :row-class-name="(record, index) => (index % 2 === 1 ? 'table-striped' : null)"
        :pagination="{
          showSizeChanger: true,
          pageSizeOptions: ['5', '10', '20', '30', '50', '75'],
          showTotal: (total, range) => `Menampilkan ${range[0]}-${range[1]} Hasil ${total} `,
          total: state.meta.total,
          pageSize: state.meta.per_page,
          current: state.meta.page,
        }"
        @change="handleTableChange"
        :loading="state.isFetching"
      >
        <template #no="{ index }">
          <span>
            {{ (state.meta.page - 1) * state.meta.per_page + 1 + index }}
          </span>
        </template>

        <template #status="{ text }">
          <ATag v-if="text" color="#108ee9">Aktif</ATag>
          <ATag v-else color="grey">Tidak Aktif</ATag>
        </template>

        <template #action="{ record }">
          <ASpace>
            <ATooltip title="Edit">
              <AButton
                class="button"
                size="small"
                @click="btnForm(record)"
                :disabled="record.is_action_disable"
              >
                <i class="fe fe-edit" />
              </AButton>
            </ATooltip>
          </ASpace>
        </template>

        <template #expandedRowRender="{record}">
          <MdTable :columns="state.columnChild" :data-source="record.clusters" :pagination="false">
          </MdTable>
        </template>
      </MdTable>
    </div>

    <!-- form -->
    <Form
      v-if="visibleFormModal"
      v-model:visible="visibleFormModal"
      v-model:item="visibleFormItemModal"
      @success="fetchDataList"
    />
  </div>
</template>

<script>
import { defineComponent, ref, reactive, onMounted } from 'vue'
import apiClient from '@/services/axios'
import { Modal, message } from 'ant-design-vue'
import FilterOpco from '@/components/filter/FilterOpco'
import FilterProvince from '@/components/filter/FilterProvince'
import FilterCLusterMaster from '@/components/filter/FilterCLusterMaster'
import DownloadExcel from '@/components/Molecules/DownloadExcel'
import Form from './Form'
import { pickBy } from 'lodash'
import { hasRoles, ROLE_ADMIN_BK } from '@/helpers'

export default defineComponent({
  components: {
    FilterOpco,
    FilterProvince,
    FilterCLusterMaster,
    DownloadExcel,
    Form,
  },
  setup() {
    const errorMessage = ref()
    const state = reactive({
      columns: [
        {
          title: 'NO',
          slots: { customRender: 'no' },
        },
        {
          title: 'Nama Grup',
          dataIndex: 'group',
        },
        {
          title: 'Area AP',
          dataIndex: 'Area_AP',
        },
        {
          title: 'Provinsi',
          dataIndex: 'provinsi',
        },
        {
          title: 'Status',
          dataIndex: 'status',
          slots: { customRender: 'status' },
        },
        {
          title: 'Action',
          slots: { customRender: 'action' },
        },
      ],
      columnChild: [
        {
          title: 'Cluster',
          dataIndex: 'cluster',
        },
        {
          title: 'Min',
          dataIndex: 'min',
        },
        {
          title: 'Max',
          dataIndex: 'max',
        },
      ],
      endpoint: {
        current: '/api/cluster/config',
        delete: '/api/cluster/config/delete', // /api/cluster/config/delete/{id}
      },
      data: [],
      meta: {
        per_page: 10,
        page: 1,
        total: 0,
      },
      isFetching: false,
      params: {
        q: '',
        opco: [],
        provinsi: [],
        cluster: [],
        page: 1,
        'per-page': 10,
      },
    })

    const handleTableChange = (page, filters, sorter) => {
      state.params.page = page.current
      state.params['per-page'] = page.pageSize

      fetchDataList()
    }

    const queryParams = () => {
      let params = state.params

      return pickBy(params)
    }

    // fetch list data
    const fetchDataList = () => {
      state.isFetching = true

      apiClient
        .get(state.endpoint.current, {
          params: queryParams(),
        })
        .then(({ data }) => {
          const { items, _meta } = data

          state.data = items
          state.meta.page = _meta.currentPage
          state.meta.per_page = _meta.perPage
          state.meta.total = _meta.totalCount
        })
        .finally(() => {
          state.isFetching = false
        })
    }

    // handle form
    const visibleFormModal = ref(false)
    const visibleFormItemModal = ref(null)

    const btnForm = (item = null, readOnly = false) => {
      visibleFormModal.value = true
      visibleFormItemModal.value = {
        ...item,
        readOnly,
      }
    }

    // handle vue
    onMounted(() => {
      fetchDataList()
    })

    return {
      visibleFormModal,
      visibleFormItemModal,
      btnForm, // create or update
      fetchDataList,
      state,
      handleTableChange,
      errorMessage,
      // only variable role
      hasRoles,
      ROLE_ADMIN_BK,
    }
  },
})
</script>
